module.exports = __webpack_public_path__ + "img/talron-menu-bars.799c6bee.svg";